import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import LayoutLldd from '../components/LayoutLldd';
import HomeMenu from '../components/HomeMenu';
import Banner from '../components/Banner';
import HorizontalFormContact from '../components/HorizontalFormContact';

import '../assets/styles/components/Home.sass';

const HomeNoExcuses = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(`https://la-leyenda.com/2018/api/general-by-id/45`)
    .then(res => res.json())
    .then((res) => {
        setData(res);
      }
    )
  }, []);

  return(
    <LayoutLldd
      title={data.seo_title_es}
      description={data.seo_content_es}
    >
      <Banner/>
      <HorizontalFormContact />
      <HomeMenu />
      <div class="row no-gutters contenido_min">
        { ReactHtmlParser(data.content) }
      </div>

    </LayoutLldd>
  )
}

export default HomeNoExcuses;
